<!--
 * @Description: 
 * @Version: 2.0
 * @Author: Zed
 * @Date: 2020-10-10 13:47:16
 * @LastEditors: Zed
 * @LastEditTime: 2020-10-13 10:32:14
-->
<template>
  <el-table :data="list" :show-header="!hideHeader" style="width: 100%" @row-click="onInfo">
    <el-table-column :show-overflow-tooltip="true" label="项目名称" prop="projectName">
      <template slot-scope="scope">
        <a href="javascript:;" class='sucess'>{{ scope.row.projectName }}</a>
      </template>
    </el-table-column>
    <el-table-column :show-overflow-tooltip="true" label="发布日期" prop="createTime" width="180">
      <template slot-scope="scope">
        <div class="release-time">{{ scope.row.createTime }}</div>
      </template>
    </el-table-column>
    <div slot="empty" class="empty">
      <el-empty description="暂无数据" />
    </div>
  </el-table>
</template>

<script>
export default {
  props: {
    list: Array,
    hideHeader: Boolean
  },
  methods: {
    onInfo(row) {
      // console.log(row);
      sessionStorage.setItem("projectId", row.projectId);
      sessionStorage.setItem("bulletinId", row.id);
      this.$router.push({
        path: "/purchase/info",
        query: {
          noticeId: row.noticeId,
          projectId: row.projectId,
          type:3
        }
      })
    },
  }
}
</script>

<style lang="less" scoped>
.release-time {
  color: #999999;
}

.sucess {
  color: #131313;
  text-decoration: none;
}
</style>